module.exports = __webpack_public_path__ + "static/media/Colette Curve Super King Headboard - 200 cm_Blush Pink.a6c0fa94.png";